import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LandingNavbar = () => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const languages = [
    { code: 'ca', name: 'Catalan' },
    { code: 'en', name: 'English' },
    { code: 'es', name: 'Spanish' },
  ];

  return (
    <nav className="bg-blue-600 shadow-md sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          {/* Left side: Logo/Title */}
          <div className="flex items-center">
            <Link to="/" className="flex-shrink-0 flex items-center">
              <span className="text-xl font-bold text-white">School Menus</span>
            </Link>
          </div>

          {/* Right side: Pricing, Language Selector & Login */}
          <div className="flex items-center space-x-4">
            {/* Pricing Link - Now positioned with the right-side elements */}
            <Link to="/pricing" className="px-3 py-2 text-sm font-bold text-white hover:text-blue-200 hover:underline transition-colors">
              {t('landing.nav.pricing', 'Pricing')}
            </Link>
            
            {/* Language Flags (Exact styling from LanguageSelector) */}
            <div className="flex items-center space-x-2">
              {languages.map((lang) => {
                const isSelected = i18n.language === lang.code;
                const flagPath = `/flags/${lang.code}.png`;
                const defaultRingColor = '#FFFFFF'; // White ring for selected flag on blue background
                return (
                  <button
                    key={lang.code}
                    onClick={() => changeLanguage(lang.code)}
                    // Exact classes from LanguageSelector, removing flex/width/height previously added
                    className={`p-1 rounded-md transition-opacity duration-200 ${isSelected ? 'ring-2 ring-offset-2 ring-offset-blue-600' : 'opacity-60 hover:opacity-100'}`}
                    style={{
                      ringColor: isSelected ? defaultRingColor : 'transparent', // Use default or transparent
                    }}
                    title={lang.name}
                    aria-label={`Switch to ${lang.name}`}
                    aria-pressed={isSelected}
                  >
                    <img 
                      src={flagPath} 
                      alt={`${lang.name} flag`} 
                      // Exact classes from LanguageSelector
                      className="w-8 h-6 object-cover rounded-sm" // Added rounded-sm like original buttons
                      style={{
                         // Exact style from LanguageSelector
                        filter: isSelected ? 'none' : 'grayscale(30%)'
                      }}
                    />
                  </button>
                );
              })}
            </div>

            {/* Login/Signup Button */}
            <Link 
              to="/login" 
              className="px-4 py-2 text-sm font-medium text-blue-700 bg-white rounded-md hover:bg-blue-50 transition-colors"
            >
              {t('navbar.loginSignup', 'Login / Sign Up')}
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default LandingNavbar; 